export default "__VITE_ASSET__Cll6EC2d__"